import { CandidateFormDialog } from "#candidate/components/candidate-form/CandidateForm"
import MainDetailsHeader from "#core/components/main-details/MainDetailsHeader"
import { STATUS } from "#vacancy/constants"
import { useVacanteRedux } from "#vacancy/redux/slice"
import { vacancyHistoryGet } from "#vacancy/services/api"
import { useReloadDetalle } from "#vacantes/redux/actions"
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn"
import CancelIcon from "@mui/icons-material/Cancel"
import GppGoodIcon from "@mui/icons-material/GppGood"
import GroupAddIcon from "@mui/icons-material/GroupAdd"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { Chip } from "@mui/material"
import { generatePath } from "react-router-dom"
import VacancyAuth from "../vacancy-auth/VacancyAuth"
import VacancyDialogCanceled from "../vacancy-dialog/VacancyDialogCanceled"
import VacancyDialogPublishingVacancy from "../vacancy-dialog/VacancyDialogPublishingVacancy"
import VacancyDetailsHistory from "./VacancyDetailsHistory"
import PERMISOS from "#constants/perfiles"
import { UseHasPermission } from "#hooks/useHasPermission"

export default function VacancyDetailsHead() {
	const isRh = UseHasPermission(PERMISOS.RH)
	const { vacancy } = useVacanteRedux()
	const refresh = useReloadDetalle()
	if (!vacancy) return null
	const title = `# ${vacancy.id} ${vacancy.perfil_puesto_name} (${vacancy.sucursal_name})`
	const subtitle = `${vacancy.tipo_vacante} ${
		vacancy?.colaborador ? `de ${vacancy?.colaborador_name}` : ""
	}`
	const is_disabled = [STATUS.CANCELED, STATUS.REJECTED].includes(vacancy.status)
	let color = is_disabled ? "error" : "success"

	const chips = <Chip label={vacancy.status_name} color={color} size={"medium"} />

	const buttons = [
		{
			title: "Historial",
			icon: ScheduleIcon,
			component: (props) => (
				<VacancyDetailsHistory
					{...{ vacancyId: vacancy.id, ...props }}
					apiCall={vacancyHistoryGet}
				/>
			),
		},
		{
			title: "Agregar Candidato",
			icon: GroupAddIcon,
			component: CandidateFormDialog,
			hidden:
				[STATUS.TO_BE_AUTHORIZED, STATUS.AUTHORIZED, STATUS.COMPLETED].includes(
					vacancy.status
				) ||
				!isRh ||
				is_disabled,
		},
		{
			title: "Publicar vacante",
			icon: AssignmentTurnedInIcon,
			component: VacancyDialogPublishingVacancy,
			hidden: vacancy.status !== STATUS.AUTHORIZED || !isRh,
		},

		{
			title: "Vobo's",
			icon: GppGoodIcon,
			hidden: vacancy.habilitado,
			component: VacancyAuth,
			color: "success",
		},
		{
			title: "Cancelar Vacante",
			icon: CancelIcon,
			hidden:
				[STATUS.CANCELED, STATUS.COMPLETED, STATUS.REJECTED].includes(vacancy.status) ||
				!isRh,
			color: "error",
			component: VacancyDialogCanceled,
		},
		{
			title: "Ver Perfil Puesto",
			icon: OpenInNewIcon,
			component: () => <></>,
			color: "success",
			onClick: () => {
				const path = generatePath("/perfil-puesto/" + vacancy.perfil_puesto)
				window.open(path, "_blank")
			},
		},
	]
	return (
		<MainDetailsHeader
			{...{ title, subtitle, buttons }}
			data={vacancy}
			refresh={refresh}
			chips={chips}
			noUsePaper
		/>
	)
}
